import { fromJS } from 'immutable';
import { extendTheme as extend, vivus as vivusTheme, onea as oneaTheme } from '4finance-components-pl';
import defaultTheme from './defaultTheme';
/**
 * Create extended theme from desired theme and custom styles.
 * @param {string} themeName Theme name ('vivus' or 'onea')
 * @param {Object} inputTheme Styles object
 * @return {Object} Created theme
 */

export default function createExtendedTheme() {
  var themeName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var inputTheme = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var theme = themeName === 'onea' ? oneaTheme : vivusTheme;
  return extend(theme, fromJS(defaultTheme).mergeDeep(inputTheme));
}